import { submitFlow } from '@/mocks/home';

export default function SubmitFlow() {
  return (
    <section id="flow" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="w-full">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <span className="font-heading text-sm tracking-widest text-secondary-700">投稿流程</span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
              从你按下提交，到编辑回信
            </h2>
          </div>
          <p className="text-sm md:text-base leading-7 text-foreground-600 max-w-md">
            我们把投稿拆成了四个看得见的步骤，你可以清楚知道自己的线索现在走到哪一步。
          </p>
        </div>

        <ol className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {submitFlow.map((s, i) => (
            <li key={s.step} className="relative flex flex-col p-6 rounded-lg bg-background-100 border border-background-200">
              <div className="flex items-center justify-between">
                <span className="font-heading text-4xl text-primary-500 leading-none">{s.step}</span>
                {i < submitFlow.length - 1 && (
                  <i className="hidden lg:block ri-arrow-right-line text-2xl text-background-400"></i>
                )}
              </div>
              <h3 className="mt-5 text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-3 text-sm leading-7 text-foreground-600">{s.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 p-6 rounded-lg bg-accent-100 border border-accent-200">
          <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
            <i className="ri-lightbulb-flash-line text-2xl"></i>
          </span>
          <p className="text-sm md:text-base leading-7 text-foreground-800">
            <strong className="font-bold">小提醒：</strong>线索详情里写清「大概什么时候、在哪里、谁在场、你通过什么途径知道」，
            会比华丽的描述更快被编辑采用。材料不方便文字化时，也可以在投稿后通过编辑回信的方式补充。
          </p>
        </div>
      </div>
    </section>
  );
}